import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { ObjectResolverBase } from '../../shared/base/object-resolver-base';

import { Lesson } from './lesson';
import { LessonService } from './lesson.service';

@Injectable()
export class LessonResolver extends ObjectResolverBase<Lesson> {
  constructor(service: LessonService, router: Router) {
    super(service, router);
  }
}



// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/lessons/shared/lesson-resolver.service.ts